import VMessages from './VMessages'

export { VMessages }
export default VMessages



// WEBPACK FOOTER //
// ../../../src/components/VMessages/index.ts